import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Chart_Image from "../assets/Analytics_Dashboard.png";
import { Button, Typography } from "antd";
import { useMsal } from "@azure/msal-react";

function Login() {
  const [darkMode, setDarkMode] = useState(false);
  const { Title, Text } = Typography;
  const { instance } = useMsal();
  const navigate = useNavigate();

  // useEffect(() => {
  //   const isAuthenticated = localStorage.getItem("isAuthenticated") === "true";

  //   if (isAuthenticated) {
  //     navigate("/");
  //   }
  // }, []);

//..18.06.2026..//
useEffect(() => {
  const token = sessionStorage.getItem("token");
  const isAuthenticated =
    localStorage.getItem("isAuthenticated") === "true";
 
  if (token && isAuthenticated) {
    navigate("/", { replace: true });
  }
}, [navigate]);

  const handleSSOLogin = () => {
instance.loginRedirect({
  scopes: ["openid", "profile"],
  prompt: "select_account",
  redirectStartPage: "/auth/callback",
});
  };

  return (
    <div className="min-h-screen flex">
      {/* LEFT SIDE (IMAGE) */}
      <div
        className={`w-1/2 hidden md:flex items-center justify-center p-10 ${
          darkMode
            ? "bg-gray-900"
            : "bg-gradient-to-br from-blue-900 to-blue-600"
        }`}
      >
        <img
          src={Chart_Image}
          alt="Analytics"
          className="max-w-full h-auto rounded-xl shadow-2xl"
        />
      </div>

      {/* RIGHT SIDE (SSO LOGIN) */}
      <div className="w-full md:w-1/2 flex items-center justify-center bg-white relative px-6">
        <div className="absolute inset-0 opacity-5">
          <div
            className="w-full h-full"
            style={{
              backgroundImage:
                "radial-gradient(circle at 1px 1px, #3b82f6 1px, transparent 0)",
              backgroundSize: "20px 20px",
            }}
          />
        </div>

        <div className="w-full max-w-md relative z-10 text-center">
          <Title level={3}>Welcome to KebiAI</Title>
          <Text type="secondary">
            Sign in using your Microsoft account
          </Text>

          <div className="mt-6">
            <Button
              type="primary"
              size="large"
              block
              onClick={handleSSOLogin}
            >
              Sign in with Microsoft
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;